
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useProfile } from '@/hooks/useProfile';

export const useAuthRedirect = () => {
  const { user, loading: authLoading } = useAuth();
  const { profile, loading: profileLoading } = useProfile();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect while loading
    if (authLoading || profileLoading) return;

    const currentPath = location.pathname;
    
    console.log('useAuthRedirect - Current path:', currentPath, {
      user: !!user,
      onboardingCompleted: profile?.onboarding_completed,
      authLoading,
      profileLoading
    });

    // Public routes that don't require authentication
    const publicRoutes = ['/', '/guest-journal'];
    
    // If user is not authenticated
    if (!user) {
      // Only redirect from protected routes, not from public routes
      if (!publicRoutes.includes(currentPath)) {
        console.log('useAuthRedirect - No user, redirecting to home from:', currentPath);
        navigate('/', { replace: true });
      }
      return;
    }

    // User is authenticated but not onboarded - redirect to streamlined onboarding
    if (!profile?.onboarding_completed && currentPath !== '/onboarding' && !publicRoutes.includes(currentPath)) {
      console.log('useAuthRedirect - User not onboarded, redirecting to streamlined onboarding');
      navigate('/onboarding', { replace: true });
    }

    // User is authenticated and onboarded - redirect from onboarding page to dashboard
    if (profile?.onboarding_completed && currentPath === '/onboarding') {
      console.log('useAuthRedirect - Onboarded user on onboarding page, redirecting to dashboard');
      navigate('/dashboard', { replace: true });
    }
  }, [user, profile, authLoading, profileLoading, navigate, location.pathname]);

  return {
    user,
    profile,
    authLoading,
    profileLoading,
    isAuthenticated: !!user,
    isOnboarded: !!profile?.onboarding_completed
  };
};
